<div class="block h-full max-h-inherit min-h-inherit w-full rounded-base bg-grey-25 shadow-lg">
  <ng-template cdkPortalOutlet></ng-template>
</div>
